import { z } from "zod";

export const ZReportChapterNodeSchema = z.lazy(() =>
  z.object({
    id: z.string().min(1),
    title: z.string().min(1),
    isActive: z.boolean(),
    text: z.string().optional(),
    children: z.array(ZReportChapterNodeSchema).optional(),
    isDisabled: z.boolean().optional(),
  }),
);

export const ZReportChaptersSchema = z.array(ZReportChapterNodeSchema);

export type IReportChapterNode = z.infer<typeof ZReportChapterNodeSchema>;
export type IReportChapters = z.infer<typeof ZReportChaptersSchema>;
